// Capacidad de plataforma "Corrección de datos con motivo" (decisión 2026-06-24).
//
// Un actor autorizado (capacidad `puede_corregir_datos`, default coordinador)
// puede CORREGIR registros de producción existentes o CREAR retroactivamente
// los que faltaron. SIEMPRE con motivo ≥20 chars y todo auditado.
//
// Diferencia con la edición del líder/supervisor (editarRegistroSchema): acá el
// `razon` es SIEMPRE obligatorio (no hay rama de "ventana libre sin motivo").
import { z } from 'zod';
import { loteCampoSchema } from './formato_lote.js';
import { registroProduccionHoraCreateSchema } from './registro_produccion_hora.js';
/** Motivo obligatorio de toda corrección/alta. ≥20 chars (espejo del CHECK BD). */
const razonCorreccion = z
    .string()
    .trim()
    .min(20, 'Motivo obligatorio (mínimo 20 caracteres)')
    .max(500, 'Máximo 500 caracteres');
/**
 * PATCH /api/correcciones/registros-produccion/:id — corregir un registro
 * existente. Campos de contenido opcionales (identidad temporal inmutable),
 * pero al menos uno (≠ razon) debe cambiar. `razon` SIEMPRE requerido.
 */
export const correccionRegistroSchema = z
    .object({
    cantidad_procesada: z.number().min(0, 'No puede ser negativa').optional(),
    cantidad_kg: z.number().min(0).nullable().optional(),
    golpes_por_minuto: z.number().positive('Debe ser mayor a 0').nullable().optional(),
    numero_operarios: z
        .number()
        .int()
        .min(1, 'Mínimo 1 operario')
        .max(20, 'Máximo 20 operarios')
        .optional(),
    op_lote_oc_cliente: loteCampoSchema.optional(),
    sku_id: z.string().uuid().optional(),
    razon: razonCorreccion,
})
    .refine((o) => Object.keys(o).some((k) => k !== 'razon'), {
    message: 'Debe modificar al menos un campo',
});
/**
 * POST /api/correcciones/registros-produccion — alta retroactiva de un bloque
 * que faltó. Reusa TODAS las validaciones de captura (paros, cantidad 0,
 * golpes, horas) vía intersección + agrega `razon` obligatorio. El backend
 * fuerza origen_correccion=true e ignora flags de delegación/fuera-de-turno.
 */
export const altaRetroactivaRegistroSchema = registroProduccionHoraCreateSchema.and(z.object({ razon: razonCorreccion }));
/** Body del PATCH /api/admin/usuarios/:userId/permiso-corregir (Admin Tenant). */
export const permisoCorregirSchema = z.object({
    puede_corregir_datos: z.boolean(),
});
//# sourceMappingURL=correccion.js.map